import { useContext, useEffect, useState } from "react";
import { getSortedCollection, matchQuery } from "sprint-common-web";

import { ManzanitaPresetListingContext } from "./context/ManzanitaPresetListingContext";
import { ManzanitaPresetListingItem, mapToManzanitaPresetListingItem } from "./ManzanitaPresetListingItem";
import { ManzanitaPresetListingFilters } from "./useManzanitaPresetListingFilters";

export const useManzanitaPresetListing = (filters: ManzanitaPresetListingFilters) => {
    const [listingItems, setListingItems] = useState<ManzanitaPresetListingItem[]>([]);
    const { items, isLoading } = useContext(ManzanitaPresetListingContext);

    useEffect(() => {
        if (items.length) {
            saveData();
        }
    }, [filters.name, filters.sortBy, filters.sortOrder, items]);

    const saveData = (): void => {
        const manzanitaPresetListingItems = items.map(mapToManzanitaPresetListingItem);

        const sortedAndFilteredItems = getSortedAndFilteredItems(manzanitaPresetListingItems, filters);

        setListingItems(sortedAndFilteredItems);
    };

    return {
        listingItems,
        isLoading,
        filters,
        saveData
    };
};

const getSortedAndFilteredItems = (items: ManzanitaPresetListingItem[], filters: ManzanitaPresetListingFilters) => {
    const sortedItems = getSortedCollection(items, filters.sortBy, filters.sortOrder);

    return filterItems(sortedItems, filters.name ?? "");
};

const filterItems = (items: ManzanitaPresetListingItem[], name: string) =>
    items.filter((item) => matchQuery(item.name, name));
